import { render, staticRenderFns } from "./TreatmentModal.vue?vue&type=template&id=76b8cb85&scoped=true"
import script from "./TreatmentModal.vue?vue&type=script&lang=js"
export * from "./TreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentModal.vue?vue&type=style&index=0&id=76b8cb85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8cb85",
  null
  
)

export default component.exports